import { ChangeDetectionStrategy, Component, computed } from '@angular/core'

import { LayoutAccordion } from 'app/core/cms/generated/api-types'
import { AccordionItemComponent } from 'app/shared/accordion-item/accordion-item.component'
import { LexicalRichTextDirective } from 'app/shared/richtext/lexical-rich-text.directive'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-layout-accordion',
  templateUrl: './layout-accordion.component.html',
  styleUrls: ['./layout-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AccordionItemComponent, LexicalRichTextDirective],
  providers: [{ provide: CmsBlock, useExisting: LayoutAccordionComponent }],
})
export class LayoutAccordionComponent extends CmsBlock<LayoutAccordion> {
  readonly __typename = 'LayoutAccordion'
  protected readonly columnCount = computed(() => parseInt(this.data().columnCount?.replace('_', '') ?? '1'))
}
